export default {
  path: '/ratio-order-details',
  meta: {
    title: '订单详情',

  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-order-details`),
}



// WEBPACK FOOTER //
// ./src/views/RatioOrderDetails/router.js